export enum FILE_INPUT_SOURCES {
  REFACTOR = 'REFACTOR',
  MANUAL_TEST = 'MANUAL_TEST'
}

export enum MANUALTEST_FILETYPES {
  PARAMETER = 'PARAMETER',
  FUNCTIONAL = 'FUNCTIONAL'
}

export enum RESPONSE_STATUS {
  OK = 'OK',
  WARNING = 'WARNING',
  ERROR = 'ERROR'
}

export enum AI_MODELS {
  SNOWFLAKE_EMBED = 'snowflake_embed',
  AZURE_GPT_4o_MINI = 'azure-gpt-4o-mini',
  GENAI_PLATFORM_QWEN25_CODER = 'genai_platform_qwen2.5-coder',
  GENAI_PLATFORM_QWEN25 = 'genai_platform_qwen2.5',
  GENAI_PLATFORM_MISTRAL = 'genai_platform_mistral',
  AZURE_EMBEDDINGS = 'azure_embeddings',
  GEMINI_FLASH =  'gemini_flash',
  GENAI_PLATFORM_NEMOTRON = 'genai_platform_nemotron',
  GOOGLE_EMBEDDINGS = 'google_embeddings',
  AZURE_GPT_4o = 'azure-gpt-4o',
  GEMINI_FLASH_LITE = 'gemini_flash_lite',
  GENAI_PLATFORM_DEEPSEEK_R1 =  'genai_platform_deepseek_r1',
  GENAI_PLATFORM_LLAMA33 = 'genai_platform_llama33',
  SNOWFLAKE_EMBED_2 = 'snowflake_embed_2',
  GENAI_HUB_DEFAULT = 'genai_hub_default',
  VERTEX_CLAUDE_SONNET_4_6 = 'vertex_ai/claude-sonnet-4-6',
  VERTEX_CLAUDE_SONNET_4_5 = 'vertex_ai/claude-sonnet-4-5',
  VERTEX_CLAUDE_SONNET_4 = 'vertex_ai/claude-sonnet-4',
  VERTEX_CLAUDE_OPUS_4_6 = 'vertex_ai/claude-opus-4-6',
  VERTEX_CLAUDE_OPUS_4_5 = 'vertex_ai/claude-opus-4-5',
  VERTEX_CLAUDE_OPUS_4_1 = 'vertex_ai/claude-opus-4-1',
  VERTEX_CLAUDE_HAIKU_4_5 = 'vertex_ai/claude-haiku-4-5'
}

export enum USERS {
  ADMIN = 'admin',
  USER = 'user',
  TEST = 'test'
}

export enum PASSWORDS {
  ADMIN = '766500cb204489124acf9dbfe0fac8fa', //admintest1
  USER = '41da76f0fc3ec62a6939e634bfb6a342', //usertest1
  TEST = '6d53f5b3370ee10e2d9adae60be35539', //testdev1
}

export enum TASK_STATUSES {
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export enum AGENTS {
  REFACTOR = 'refactor',
  TESTPLAN = 'testplan',
  UNITTEST = 'unittest',
  KNOWLEDGE = 'knowledge',
  AUTOMATION = 'automation',
  USER_STORIES = 'user_stories',
  CHEW = 'chew',
  INCIDENTS = 'incidents',
  DOCGENERATOR = 'docgenerator',
  DATAMANAGER = 'datamanager',
  ANALYSIS = 'analysis'
}

export enum AGENTS_AVAILABLE {
  REFACTOR = 'REFACTOR',
  TESTPLAN = 'TESTPLAN',
  UNITTEST = 'UNITTEST',
  KNOWLEDGE = 'KNOWLEDGE',
  AUTOMATION = 'AUTOMATION',
  USER_STORIES = 'USER_STORIES',
  CHEW = 'CHEW',
  INCIDENTS = 'INCIDENTS',
  DOCGENERATOR = 'DOCGENERATOR',
  DATAMANAGER = 'DATAMANAGER'
}

export enum ROLES {
  MANAGER = 'MANAGER',
  USER = 'USER'
}

export enum ANALYSIS_MODES {
  CLEAN_CODE = 'CLEAN_CODE',
  CODE_SMELLS = 'CODE_SMELLS',
  SECURITY = 'SECURITY'
}
